type SectionHeadingProps = {
  index?: string;
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  tone?: "light" | "dark";
};

export default function SectionHeading({
  index,
  eyebrow,
  title,
  desc,
  align = "left",
  tone = "light",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  const titleColor = tone === "dark" ? "text-background-50" : "text-foreground-950";
  const descColor = tone === "dark" ? "text-background-300" : "text-foreground-600";
  const eyebrowColor = tone === "dark" ? "text-accent-400" : "text-primary-600";

  return (
    <div className={`flex flex-col gap-3 ${isCenter ? "items-center text-center" : ""}`}>
      <div className={`flex items-center gap-3 ${isCenter ? "justify-center" : ""}`}>
        {index ? (
          <span className={`font-heading text-sm font-bold ${eyebrowColor}`}>{index}</span>
        ) : null}
        <span className={`h-px w-8 ${tone === "dark" ? "bg-accent-400/60" : "bg-primary-400/60"}`} />
        {eyebrow ? <span className={`eyebrow ${eyebrowColor}`}>{eyebrow}</span> : null}
      </div>
      <h2 className={`font-heading text-2xl md:text-4xl font-bold leading-snug ${titleColor}`}>
        {title}
      </h2>
      {desc ? (
        <p className={`max-w-2xl text-sm md:text-base leading-relaxed ${descColor}`}>{desc}</p>
      ) : null}
    </div>
  );
}